const state = {
  dateRangeLoading: false,
  exportLoading: false,

  componentDates: {
    topPerformers: {},
    certifications: {},
    myProgress: {},
    teamProgress: {},
  },

  reportData: {
    dealers: [],
    categories: [],
    users: [],
  },

  dealers: [],
  users: [],
  usersFilter: [],

  searchText: null,

  reset: 0,

  categories: {
    myProgress: [],
    teamProgress: [],
  },
};

const getters = {
};

const mutations = {
  setDateRangeLoading(st, data) {
    st.dateRangeLoading = data;
  },

  setComponentDate(st, data) {
    st.componentDates[data.key] = data.value;
  },

  setReportData(st, data) {
    st.reportData = data;
  },

  setDealers(st, data) {
    st.dealers = data;
  },

  setExportLoading(st, data) {
    st.exportLoading = data;
  },

  setSearchText(st, data) {
    st.searchText = data;
  },

  setUsers(st, data) {
    st.users = data;
  },

  setUsersFilter(st, data) {
    st.usersFilter = data;
  },

  incrementReset(st) {
    st.reset += 1;
  },

  setCategories(st, data) {
    st.categories[data.type] = data.value;
  },
};

const actions = {
  setDateRangeLoading({ commit }, payload) {
    commit('setDateRangeLoading', payload);
  },

  setComponentDate({ commit }, payload) {
    commit('setComponentDate', payload);
  },

  setReportData({ commit }, payload) {
    commit('setReportData', payload);
  },

  setDealers({ commit }, payload) {
    commit('setDealers', payload);
  },

  setExportLoading({ commit }, payload) {
    commit('setExportLoading', payload);
  },

  setSearchText({ commit }, payload) {
    commit('setSearchText', payload);
  },

  setUsers({ commit }, payload) {
    commit('setUsers', payload);
  },

  setUsersFilter({ commit }, payload) {
    commit('setUsersFilter', payload);
  },

  incrementReset({ commit }) {
    commit('incrementReset');
  },

  setCategories({ commit }, data) {
    commit('setCategories', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
